<template>
  <q-dialog
    :model-value="numberOfFilesToUpload > 0"
    persistent
  >
    <q-card
      class="q-pa-xl"
      style="width: 420px; max-width: 80vw;"
    >
      <div
        v-if="allUploadAreDone == false"
        class="q-card shadow-borderrow wrap justify-start q-pa-sm"
      >
        <div class="col-12 q-py-sm text-center justify-center">
          <q-circular-progress
            v-if="waitBetweenUploads == false"
            show-value
            font-size="12px"
            :value="uploadProgress.progress"
            size="48px"
            :thickness="0.2"
            color="primary"
            track-color="grey-2"
            class="q-ma-md"
          >
            {{ Math.round(uploadProgress.progress) }}%
          </q-circular-progress>

          <q-circular-progress
            v-else
            font-size="12px"
            indeterminate
            size="48px"
            :thickness="0.2"
            color="primary"
            track-color="grey-2"
            class="q-ma-md"
          />
        </div>
        <div class="col-12 q-py-none q-pb-md  text-center">
          <p class="text-subtitle2  q-mb-none">
            {{ i18n.upload_in_progress(numberOfFilesToUpload - filesToUpload, numberOfFilesToUpload) }}
          </p>
          <span class="text-caption text-seconday">{{ i18n.please_wait }}</span>
        </div>
      </div>

      <div
        v-else
        class="row wrap justify-start q-pa-sm"
      >
        <div class="col-12 q-py-sm text-center justify-center">
          <q-icon
            name="fa-solid fa-check"
            size="48px"
            color="positive"
          />
        </div>
        <div class="col-12 q-py-none q-pb-md  text-center">
          <p class="text-subtitle2  q-mb-none">
            {{ i18n.upload_done }}
          </p>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script setup>
import frQuasar from "quasar/lang/fr";
import enQuasar from "quasar/lang/en-US";
import { ref } from 'vue';
import { onBeforeMount } from 'vue';
import { getCurrentInstance } from "vue";
const instance = getCurrentInstance();
defineProps({
  uploadProgress: Object,
  waitBetweenUploads: Boolean,
  allUploadAreDone: Boolean,
  numberOfFilesToUpload: Number,
  filesToUpload: Number
})

const i18n = ref({});

onBeforeMount(() => {
  locale(instance?.proxy.$q.lang.isoName);
})

function locale(locale) {
  switch (locale) {
  case enQuasar.isoName:
    i18n.value.please_wait = "Please wait...";
    i18n.value.upload_completed = "Upload completed";
    i18n.value.upload_in_progress = function(a, b) { return `Upload in progress (${a}/${b})` }
    i18n.value.upload_done = `Upload completed`;
    break;
  case frQuasar.isoName:
  default:
    i18n.value.please_wait = "Veuillez patienter...";
    i18n.value.upload_completed = "Upload completed";
    i18n.value.upload_in_progress = function(a, b) { `Téléversement en cours (${a}/${b})` }
    i18n.value.upload_done = `Téléversement terminé`;
    break;
  }
}
</script>
